import ResourceApi from '../ResourceApi';

const UserTimeEntryResource = {
  index: async (userId, params = {}) => (
    await ResourceApi.get(`/resource/users/${userId}/time-entries`, params)
  ).data,
};

export default UserTimeEntryResource;
